import { render, staticRenderFns } from "./BlockListTextCustom.vue?vue&type=template&id=04020f62"
import script from "./BlockListTextCustom.vue?vue&type=script&lang=js"
export * from "./BlockListTextCustom.vue?vue&type=script&lang=js"
import style0 from "./BlockListTextCustom.vue?vue&type=style&index=0&id=04020f62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports